import React from 'react'
import './index.css'
import { LaunchDarklyProvider } from 'sidecar-component-library'
import { BrowserRouter as Router } from 'react-router-dom'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { ToastProvider, TooltipProvider } from 'sidecar-components'
import { webStorage } from 'sidecar-utilities'

import ReduxProvider from 'store'
import { App } from 'pages/App/App'
import { Maintenance } from 'pages/Maintenance'
import {
  LDContextIdentifier,
  identifyMember,
} from 'components/_common/LDContextIdentifier'
import { SplashScreen } from 'components/_common/SplashScreen'
import { SidekickProvider } from 'contexts/SidekickProvider'
import { MemberCommsProvider } from 'contexts/MemberCommsProvider'

// init code for DataDog monitoring
import 'utils/monitoring/datadog'

// init code for Google Tag Manager (loaded AFTER Datadog to prevent CORS issues)
import 'utils/thirdParty/gtm'

const AppRoot = () => {
  const flags = useFlags()

  // The SplashScreen is a separate component because it has some state
  // that it updates. We don't want to do that here so that this component
  // doesn't re-render, causing App to re-render and so on down the line.
  return (
    <>
      <SplashScreen />
      {flags['maintenance-mode'] ? <Maintenance /> : <App />}
    </>
  )
}

const context = identifyMember(webStorage.getItem('token'))

// the actual mounting of this via ReactDom.render
// takes places inside of LaunchDarklyProvider
LaunchDarklyProvider(context)(
  <ReduxProvider>
    <ToastProvider duration={10000} label="Notifications" swipeDirection="down">
      <TooltipProvider delayDuration={600}>
        <Router>
          <MemberCommsProvider>
            <SidekickProvider>
              <LDContextIdentifier />
              <AppRoot />
            </SidekickProvider>
          </MemberCommsProvider>
        </Router>
      </TooltipProvider>
    </ToastProvider>
  </ReduxProvider>,
)
